import { FontIcon, tokens } from '@arvoreeducacao/bonsai-ds'
import React from 'react'
import {
  DropdownHeaderText,
  DropdownHeaderWrapper,
  DropdownItem,
  DropdownMenuItemsWrapper,
  DropdownListWrapper,
  DropdownTextItem,
  WrapperCaretIcon
} from './DropdownMenuItems.styles'
import { useHistory } from 'react-router-dom'
import { useAdminSidebarStore } from 'stores/adminSidebarStore'
import useDropdownMenuItems from './useDropdownMenuItems'
import type { DropdownMenuItemsProps } from '../types'

const DropdownMenuItems = ({
  title,
  items,
  iconName,
  isActive = false,
  onToggle
}: DropdownMenuItemsProps) => {
  const history = useHistory()
  const { close } = useAdminSidebarStore()
  const { isCurrentPath } = useDropdownMenuItems(items)

  const handleToggle = () => {
    if (onToggle) {
      onToggle()
    }
  }

  return (
    items &&
    items.length > 0 && (
      <DropdownMenuItemsWrapper active={isActive}>
        <DropdownHeaderWrapper onClick={handleToggle}>
          <FontIcon
            iconName={iconName}
            color={tokens.colors.livrosMedium}
            size={20}
          />
          <DropdownHeaderText>{title}</DropdownHeaderText>
          <WrapperCaretIcon>
            <FontIcon
              iconName={isActive ? 'caret-up' : 'caret-down'}
              color={tokens.colors.dark4}
              size={16}
            />
          </WrapperCaretIcon>
        </DropdownHeaderWrapper>
        <DropdownListWrapper isDropdownActive={isActive}>
          {items.map((item, index) => {
            const isArrayPath = Array.isArray(item?.path)
            const targetPath = isArrayPath ? item?.path[0] : item?.path
            const isExternalPath = targetPath?.startsWith('/app-v2')

            const handleClick = () => {
              close()
              if (isExternalPath) {
                window.location.href = targetPath
              } else {
                history.push(targetPath)
              }
            }

            return (
              <DropdownItem
                key={index}
                onClick={handleClick}
                isCurrentPath={isCurrentPath(item)}
              >
                <DropdownTextItem>{item.title}</DropdownTextItem>
              </DropdownItem>
            )
          })}
        </DropdownListWrapper>
      </DropdownMenuItemsWrapper>
    )
  )
}

export default DropdownMenuItems
